<script>
  import TrendChart from './TrendChart.vue';

  export default {
    name: 'InjectionsPerMonth',
    extends: TrendChart,
    data() {
      return {
        chartId: 'injectionsPerMonth',
        fields: [
          'num_injections',
        ],
      };
    },
  };
</script>
